/* eslint-disable */
export default {
  install(Vue, store) {
    // console.log('store getters =', store.getters)

    const colors = {
      infoBg:    ['background-color: rgba(37, 99, 235, 1)',   'color: white', 'padding: 3px 3px 3px 4px', 'border-radius: 0.175rem'].join(';'),
      debugBg:   ['background-color: rgba(156, 163, 175, 1)', 'color: white', 'padding: 3px 3px 3px 4px', 'border-radius: 0.175rem'].join(';'),
      errorBg:   ['background-color: rgba(220, 38, 38, 1)',   'color: white', 'padding: 3px 3px 3px 4px', 'border-radius: 0.175rem'].join(';'),
      fatalBg:   ['background-color: rgba(0,0,0,1)',          'color: white', 'padding: 3px 3px 3px 4px', 'border-radius: 0.175rem'].join(';'),
      warnBg:    ['background-color: rgba(217, 119, 6, 1)',  'color: white', 'padding: 3px 3px 3px 4px', 'border-radius: 0.175rem'].join(';'),
      successBg: ['background-color: rgba(5, 150, 105, 1)',   'color: white', 'padding: 3px 3px 3px 4px', 'border-radius: 0.175rem'].join(';'),
      normalBg:  ['background-color: rgba(235,235,235,1)',    'color: #ccc', 'padding: 3px 3px 3px 4px', 'border-radius: 0.175rem'].join(';'),

      infoTxt:    ['color: rgba(37, 99, 235, 1)',   'padding: 3px 4px', 'border-radius: 0.175rem'].join(';'),
      debugTxt:   ['color: rgba(156, 163, 175, 1)', 'padding: 3px 4px', 'border-radius: 0.175rem'].join(';'),
      errorTxt:   ['color: rgba(220, 38, 38, 1)',   'padding: 3px 4px', 'border-radius: 0.175rem'].join(';'),
      fatalTxt:   ['color: rgba(220, 38, 38, 1)',   'padding: 3px 4px', 'border-radius: 0.175rem'].join(';'),
      warnTxt:    ['color: rgba(217, 119, 6, 1)',  'padding: 3px 4px', 'border-radius: 0.175rem'].join(';'),
      successTxt: ['color: rgba(16, 185, 129, 1)',  'padding: 3px 4px', 'border-radius: 0.175rem'].join(';'),
      normalTxt:  ['color: #444',                'padding: 3px 4px', 'border-radius: 0.175rem'].join(';')
    }

    function log(type, title, text, value) {
      // console.log('\n>>> TYPE =', type);
      // console.log('\n>>> TITLE =', title);
      // console.log('\n>>> TEXT =', text);
      // console.log('\n>>> VALUE =', value);

      if (store.getters['settings/getConsole']) {
        switch (type) {
          case 'debug': {
            // const val = convertToStringOutput(value)
            // console.log('\n>>> switch:debug >> val =',  val);
            // console.debug(`%c[${type}]%c${title}: ${text} - ${val}`, colors.debugBg, colors.debugTxt)
            console.debug(`%c[${type}]%c${title}: ${text}:`, colors.debugBg, colors.debugTxt)
            console.log(value)
            console.log('\n')
            break
          }

          case 'info': {
            // const val = convertToStringOutput(value)
            // console.log('\n>>> switch:info >> val =',  val);
            // console.info(`%c[${type}]%c${title}: ${text} - ${val}`, colors.infoBg, colors.infoTxt)
            console.info(`%c[${type}]%c${title}: ${text}:`, colors.infoBg, colors.infoTxt)
            console.log(value)
            console.log('\n')
            break
          }

          case 'warn': {
            // const val = convertToStringOutput(value)
            // console.log('\n>>> switch:warn >> val =',  val);
            // console.warn(`%c[${type}]%c${title}: ${text} - ${val}`, colors.warnBg, colors.warnTxt)
            console.warn(`%c[${type}]%c${title}: ${text}:`, colors.warnBg, colors.warnTxt)
            console.log(value)
            console.log('\n')
            break
          }

          case 'fatal': {
            // const val = convertToStringOutput(value)
            // console.log('\n>>> switch:fatal >> val =',  val);
            // console.error(`%c[${type}]%c${title}: ${text} - ${val}`, colors.fatalBg, colors.fatalTxt)
            console.error(`%c[${type}]%c${title}: ${text}:`, colors.fatalBg, colors.fatalTxt)
            console.log(value)
            console.log('\n')
            break
          }

          case 'error': {
            // const val = convertToStringOutput(value)
            // console.log('\n>>> switch:error >> val =',  val);
            // console.error(`%c[${type}]%c${title}: ${text} - ${val}`, colors.errorBg, colors.errorTxt)
            console.error(`%c[${type}]%c${title}: ${text}:`, colors.errorBg, colors.errorTxt)
            console.log(value)
            console.log('\n')
            break
          }

          case 'success': {
            // const val = convertToStringOutput(value)
            // console.log('\n>>> switch:success >> val =',  val);
            // console.log(`%c[${type}]%c${title}: ${text} - ${val}`, colors.successBg, colors.successTxt)
            console.log(`%c[${type}]%c${title}: ${text}`, colors.successBg, colors.successTxt)
            console.log(value)
            console.log('\n')
            break
          }

          case 'log':
          default:
            // const val = convertToStringOutput(value)
            // console.log('\n>>> switch:log >> val =',  val);
            // console.log(`%c[${type}]%c${title}: ${text} - ${val}`, colors.normalBg, colors.normalTxt)
            console.log(`%c[${type}]%c${title}: ${text}`, colors.normalBg, colors.normalTxt)
            console.log(value)
            console.log('\n')
            break
        }
      }

      if (store.getters['settings/getDebugging']) {
        // console.log('log in: value =',  value);
        const val = convertToStringOutput(value)
        // console.log('\n>>> convertToStringOutput: log out: val =',  val);
        store.dispatch('settings/setLog', { type, title, text, val })
      }
    }

    function convertToStringOutput(object) {
      // console.log('Convert string to input: object =', object);
      let val = object

      if (object instanceof Array) {
        // console.log('LOGGER: We have ARRAY')
        val = object.join(', ')
      }
      else if (object instanceof Function) {
        // console.log('WE HAVE FUNCTION')
        val = JSON.stringify(object, null, ' ')
      }
      else if (object instanceof File) {
        // console.log('LOGGER: We have FILE')
        val = JSON.stringify(object, null, ' ')
      }

      // console.log('convertToStringOutput val =',  val);

      return val
    }

    Vue.prototype.$l = {
      /**
       * @param {string|null} title - Some string the user enters; obj when used with dir or table
       * @param {string|null} text - The value of an operation to be logged
       * @param {string|null} consoleAPI - group, groupCollapsed, table, ...
       * @param {string|null} loglabel - "group" and other console types can have a lable
       */
      debug (title, text, value) {
        log('debug', title, text, value)
      },
      info (title, text, value) {
        log('info', title, text, value)
      },
      warn (title, text, value) {
        log('warn', title, text, value)
      },
      error (title, text, value) {
        log('error', title, text, value)
      },
      fatal (title, text, value) {
        log('fatal', title, text, value)
      },
      success (title, text, value) {
        log('success', title, text, value)
      },
      log(title, text, value) {
        log('log', title, text, value)
      }
    }
  }
}
